import React from 'react'
import {QuoteDetailListTable} from "../Component/QuoteDetailListTable";

const ExpiredTabList = (props) => {
    return (
        <div>
            <QuoteDetailListTable {...props}/>
        </div>
    )
};

export default ExpiredTabList